import { CloseIcon } from '@chakra-ui/icons';
import { Badge, Box, Icon } from '@chakra-ui/react';

export function TagItem({ tag }) {
  return (
    <Box position="relative" key={tag}>
      <Badge key={tag} variant="outline" colorScheme="blue">
        {tag}
      </Badge>

      <Icon
        as={CloseIcon}
        position="absolute"
        top={0}
        right={'-3'}
        cursor="pointer"
        fontSize="8px"
        borderRadius="50%"
        bg="gray.100"
        boxShadow="md"
        color="red.500"
      />
    </Box>
  );
}
